/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SalaryRangeAnalysisJobPoint = {
    value: number;
    status: SalaryRangeAnalysisJobPoint.status;
    companyJobId: number;
    jobTitle?: string;
    jobCode?: string;
    jobFamilyTitle?: string;
};

export namespace SalaryRangeAnalysisJobPoint {

    export enum status {
        BELOW = 'below',
        WITHIN = 'within',
        ABOVE = 'above',
    }


}

